export class MailSettingKeysClass {
    constructor() {
        this.nFolderSetting = 'ntes_defined';
        this.nReplay = 'replyf';
        this.nForward = 'ntes_option';
        this.nShowMergedMail = 'mail_showMerged';
        this.nAutoAddMailContact = 'aftersend_saveaddr';
        this.nAutoAddMailContactAftForward = 'afterforward_saveaddr';
        this.nAutoAddMailContactAftReply = 'afterreply_saveaddr';
        this.nDefaultSendingAccount = 'ntes_defaultsender';
        this.nRefuseList = 'refuselist';
        this.nSaveList = 'safelist';
        this.nOriginalAccount = 'original_account';
        this.nPraiseMedals = 'praise_medals';
        this.nBannerLayout = 'banner_layout';
        this.nShowDesc = 'show_desc';
        this.nShowAttachment = 'show_attachment';
        this.nShowAvator = 'show_avator';
        this.nShowConcreteTime = 'show_concrete_time';
        this.nMailListTightness = 'mail_list_tightness';
        this.nMailListShowCustomerTab = 'mail_list_show_customer_tab';
        this.nShowCustomerCompany = 'show_customer_company';
        this.nSenderName = 'true_name';
        this.nPermRecallMail = 'perm_recall_mail';
        this.nImgBottomAlign = 'img_bottom_align';
        this.nCosId = 'cos_id';
        this.nTimezone = 'time_zone';
        this.nLocalTimezone = 'local_time_zone';
        this.nIsUseReaList = 'isUseMailRealList';
        this.nMailRealListPageSize = 'mailRealListPageSize';
        this.nNormalDayLimit = 'normalDayLimit';
        this.nThirdDayLimit = 'thirdDayLimit';
        this.nUploadSize = 'upload_size';
        this.nSmtpMaxSendMailSize = 'smtp_max_send_mail_size';
        this.fillrcptsWhenReplyall = 'fillrcpts_when_replyall';
        this.skipWmreplyAutoClassify = 'skip_wmreply_auto_classify';
        this.skipWmotherreplyAutoClassify = 'skip_wmotherreply_auto_classify';
        this.openSentMailSeenFilter = 'open_sent_mail_seen_filter';
    }
}
export var FLOLDER;
(function (FLOLDER) {
    FLOLDER[FLOLDER["DEFAULT"] = 1] = "DEFAULT";
    FLOLDER[FLOLDER["SENT"] = 3] = "SENT";
    FLOLDER[FLOLDER["DRAFT"] = 2] = "DRAFT";
    FLOLDER[FLOLDER["WAITINGISSUE"] = 17] = "WAITINGISSUE";
    FLOLDER[FLOLDER["READYISSUE"] = 19] = "READYISSUE";
    FLOLDER[FLOLDER["CUSTOMER_UNFOLLOW"] = -17] = "CUSTOMER_UNFOLLOW";
    FLOLDER[FLOLDER["UNFOLLOW"] = -18] = "UNFOLLOW";
    FLOLDER[FLOLDER["ADVITISE"] = 7] = "ADVITISE";
    FLOLDER[FLOLDER["SPAM"] = 5] = "SPAM";
    FLOLDER[FLOLDER["VIRUS"] = 6] = "VIRUS";
    FLOLDER[FLOLDER["DELETED"] = 4] = "DELETED";
    FLOLDER[FLOLDER["SUBSCRIPTION"] = 18] = "SUBSCRIPTION";
    FLOLDER[FLOLDER["ISOLATION"] = 89] = "ISOLATION";
    FLOLDER[FLOLDER["REDFLAG"] = -1] = "REDFLAG";
    FLOLDER[FLOLDER["TASK"] = -9] = "TASK";
    FLOLDER[FLOLDER["UNREAD"] = -4] = "UNREAD";
    FLOLDER[FLOLDER["EDM_REPLY"] = 21] = "EDM_REPLY";
    FLOLDER[FLOLDER["EDM_OTHER_REPLY"] = 22] = "EDM_OTHER_REPLY";
    FLOLDER[FLOLDER["STAR"] = -5] = "STAR";
    FLOLDER[FLOLDER["OTHERS"] = -2] = "OTHERS";
    FLOLDER[FLOLDER["DEFER"] = -3] = "DEFER";
    FLOLDER[FLOLDER["TAG"] = -199] = "TAG";
    FLOLDER[FLOLDER["ALL_RECEIVE"] = -41] = "ALL_RECEIVE";
    FLOLDER[FLOLDER["ALL_UNREAD"] = -42] = "ALL_UNREAD";
    FLOLDER[FLOLDER["ALL_SENT"] = -43] = "ALL_SENT";
    FLOLDER[FLOLDER["ALL_REDFLAG"] = -44] = "ALL_REDFLAG";
    FLOLDER[FLOLDER["ALL_DRAFT"] = -45] = "ALL_DRAFT";
    FLOLDER[FLOLDER["ALL_ACCOUNT"] = -46] = "ALL_ACCOUNT";
    FLOLDER[FLOLDER["ALL_CUSTOMER_UNFOLLOW"] = -47] = "ALL_CUSTOMER_UNFOLLOW";
    FLOLDER[FLOLDER["ALL_UNFOLLOW"] = -48] = "ALL_UNFOLLOW";
    FLOLDER[FLOLDER["ALL_EDM_REPLY"] = -49] = "ALL_EDM_REPLY";
    FLOLDER[FLOLDER["ALL_EDM_OTHER_REPLY"] = -50] = "ALL_EDM_OTHER_REPLY";
    FLOLDER[FLOLDER["SEARCH_ALL_RESULT"] = -33] = "SEARCH_ALL_RESULT";
})(FLOLDER || (FLOLDER = {}));
export const MailSettingKeys = new MailSettingKeysClass();
export const upload_size_local = 100 * 1024 * 1024;
export const upload_total_size_local = 100 * 1024 * 1024;
export const smtp_max_send_mail_size_local = 100 * 1024 * 1024;
export const free_upload_size_local = 100 * 1024 * 1024;
export const free_upload_total_size_local = 100 * 1024 * 1024;
export const free_smtp_max_send_mail_size_local = 100 * 1024 * 1024;
export const skipWmClassify = 'skip_wmreply_auto_classify';
export const skipWmOthClassify = 'skip_wmotherreply_auto_classify';
export const COPIED_ATTACH_KEY = 'COPIED_ATTACH';
export const NoSetDeferTime = '2200-01-01 00:00:00';
export const AllMemberType = ['to', 'cc', 'bcc', ''];
export var FolderTreeEditState;
(function (FolderTreeEditState) {
    FolderTreeEditState["DEFAULT"] = "DEFAULT";
    FolderTreeEditState["ADD"] = "ADD";
    FolderTreeEditState["UPDATE"] = "UPDATE";
    FolderTreeEditState["LOADING"] = "LOADING";
})(FolderTreeEditState || (FolderTreeEditState = {}));
export { shouldSkipPersonalSign } from './personal_sign_rule';
export const SystemAccounts = [
    'kf@qiye.163.com',
    'kf@office.163.com',
    'notice@qiye.163.com',
    'postmaster@qiye.163.com',
    'Postmaster@qiye.163.com',
    'join163@qiye.163.com',
    'service@v.qiye.163.com',
    'abuse@qiye.163.com',
    'mail@ym.163.com',
];
export const reDefinedColorList = [
    {
        color: '#6BA9FF',
        nums: [3, 8],
        className: 'color1',
    },
    {
        color: '#70CCAB',
        nums: [15, 16, 1, 10],
        className: 'color2',
    },
    {
        color: '#AA90F4',
        nums: [9, 12],
        className: 'color3',
    },
    {
        color: '#F7A87C',
        nums: [16, 7, 11, 2],
        className: 'color4',
    },
    {
        color: '#F77C7C',
        nums: [17, 5, 4, 0],
        className: 'color5',
    },
    {
        color: '#A8AAAD',
        nums: [19, 18, 14, 13],
        className: 'color6',
    },
];
export const reDefinedColorListNew = [
    {
        color: '#DEEBFD',
        nums: [3, 8],
        fontColor: '#4759B2',
        className: 'color1',
    },
    {
        color: '#D6F7F1',
        nums: [15, 16, 1, 10],
        fontColor: '#398E80',
        className: 'color2',
    },
    {
        color: '#EDE4FF',
        nums: [9, 12],
        fontColor: '#7A51CB',
        className: 'color3',
    },
    {
        color: '#FFF3E2',
        nums: [16, 7, 11, 2],
        fontColor: '#CC913D',
        className: 'color4',
    },
    {
        color: '#FFE5E2',
        nums: [17, 5, 4, 0],
        fontColor: '#CB493D',
        className: 'color5',
    },
    {
        color: '#E7EBF1',
        nums: [19, 18, 14, 13],
        fontColor: '#4E5A70',
        className: 'color6',
    },
];
